import { connect } from 'react-redux'

import { userTypingStart, algoliaUserAutocomplete } from 'Modules/autocomplete/actions'

import LeadAutoComplete from './LeadAutoComplete.js'

const mapStateToProps = state => ({
  results: state.userAutoComplete.algoResult,
  isFetching: state.userAutoComplete.algoIsFetching,
})
const actions = {
  loadAutoComplete: algoliaUserAutocomplete,
  typingStart: userTypingStart,
}

export default connect(mapStateToProps, actions)(LeadAutoComplete)
